<template>
	<el-container>
		<el-main>
			<div style="width: 90%;margin-bottom: 0px;display: flex;justify-content: space-between;height: 14px;">
				<div>
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item class="item_font">开口机器人</el-breadcrumb-item>
						<el-breadcrumb-item><span class="item_font">简单模型</span></el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<!-- <div style="text-align: right;line-height: 14px;"><el-button type="text" size="small" @click="$router.push('/setting/model')" class="item_font">返回首页</el-button></div> -->
			</div>

			<div style="margin-top: 30px;">
				<el-button type="text" size="mini" style="margin-right: 12px;color: orangered;">请先选择科室</el-button>
				<el-select v-model="department" size="mini" placeholder="请选择科室" @change="changeDep"
					style="margin-right: 12px;">
					<el-option v-for="(item , index) in departmentList" :key="index" :label="item.name"
						:value="item.depType"></el-option>
				</el-select>
			</div>

			<div class="radios">
				<el-radio-group v-model="type" style="margin-bottom: 30px;" size="mini" @change="choiceScript">
					<el-radio-button v-for="(item , index) in utterData" :key="index" :label='index'>
						{{item.sceneName}}</el-radio-button>
				</el-radio-group>
			</div>
			<div class="content" v-if="utterData.length != 0"
				style="margin-top: 30px;width: 100%;display: flex;justify-content: space-between;">
				<div style="display: flex;justify-content: flex-start;align-items: center;">
					<el-input v-model="reply_time" size='mini'
						placeholder="固定开口时间,单位为毫秒">
					</el-input>
					<el-button type="primary" size="mini" style="margin-left: 5px;" @click="saveAttr">保存</el-button>
				</div>
				<div class="buttons1">
					<el-button type="primary" size="mini" @click="clickAdd" class="item_font">新增</el-button>
				</div>
			</div>
			<div style="width: 100%;margin-top: 20px;" v-if="utterData.length != 0" class="item_font">
				<el-table stripe :data="utterData[type].utters" border highlight-current-row style="width: 100%"
					:header-cell-style="headerStyle" :cell-style="cellStyle">
					<el-table-column property="content" label="话术">
					</el-table-column>
					<el-table-column label="操作" width="150" fixed="right">
						<template slot-scope="scope">
							<div style="display: flex;flex-direction: row;justify-content: space-around;">
								<el-button @click="edit(scope.row)" type="text" size="small" class="item_font">编辑
								</el-button>
								<el-button type="text" size="small" @click="delet(scope.row)" class="item_font">删除
								</el-button>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- <div v-if="type==='7'">
				<div style="width: 100%;display: flex;justify-content: space-between;margin-top: 20px;">
					<div style="font-weight: bold;font-size: 15px;line-height: 35px;">辅助介绍</div>
					<div>
						<span style="color:#9a9a9a;font-size: 15px;line-height: 35px;">是否启用</span>
						<el-switch style="margin-left: 10px;" v-model="textobj.useFlag" active-color="#55aaff"
							inactive-color="#999999"></el-switch>
					</div>
				</div>
				<div style="width: 100%;margin-top: 20px;">
					<el-input type="textarea" cols="2" rows="4" v-model="textobj.content">
					</el-input>
				</div>
			</div>
			<el-footer>
				<div v-if="type==='7'" style="width: 160px; margin: 0 auto;margin-top: 50px;">
					<el-button type="primary" @click=save>保存</el-button>
				</div>
			</el-footer> -->
			<div v-show="addQuery">
				<el-dialog :title="addQueryTitle.title" :visible.sync="addQuery" custom-class="dialog"
					:close-on-click-modal="false" :close-on-press-escape="false" width="30%" center>
					<div style="margin-bottom: 15px;display: flex;justify-content: space-between;">
						<div>话术：</div>
						<div>
							<!-- <el-button type="" size="mini" @click="insertValue">插入变量</el-button> -->
							<!--							<el-select v-model="value" placeholder="插入变量">
								<el-option v-for="(item,index) in valueLst" :key="index" :label="item" :value="item">{{item}}</el-option>
							</el-select>-->
							<el-select v-model="changeItem" placeholder="选择插入变量" size="mini" clearable
								@change="choChangeItem">
								<el-option v-for="item in changeItemList" :key="item.varName" :label="item.name"
									:value="item.varName">
								</el-option>
							</el-select>
						</div>
					</div>
					<div style="height: 100px;">
						<el-input type="textarea" cols="2" rows="4" placeholder="请输入内容" @focus="getInputIndex"
							id="textInput" v-model="inputValue">
						</el-input>
					</div>
					<div slot="footer" class="dialog-footer">
						<el-button @click="addQuery = false">取 消</el-button>
						<el-button type="primary" @click="confirm(addQueryTitle.type)">确 定</el-button>
					</div>
				</el-dialog>
			</div>
		</el-main>
	</el-container>
</template>

<script>
	import {
		MessageBox
	} from 'element-ui';
	var textInput;
	export default {
		name: 'simplemodel',
		data() {
			return {
				start: 0,
				type: "0",
				userId: this.util.getLocalAccount().id,
				myHeaders: {
					Authorization: localStorage.getItem("token")
				},
				addQuery: false,
				onOff: true,
				inputValue: "",
				scriptData: [],
				value: "",
				addQueryTitle: {
					title: '',
					type: ""
				},
				queryID: "",
				valueLst: [],
				// deleteByIds: [],
				deleteByid: '',
				textobj: {
					content: "",
					useFlag: false
				},
				text: "",
				changeItemList: [],
				changeItem: '',
				departmentList: [],
				department: 1,
				utterData: [],
				reply_time: 0,
				sceneId:''
			}
		},
		mounted() {
			this.getDepartmentList()
			this.querySelect()
			this.getItemList();
			// this.valueSelect()
		},
		watch: {
			// type:function(newVal,oldVal){
			// 	console.log("type:",newVal,oldVal)
			// },
			value: function(newVal, oldVal) {
				console.log("value", newVal, oldVal)
			},
		},
		methods: {
			//获取变量
			async getItemList() {
				var api = "/manager/bisvariable/getbisvariable";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {},
				});
				console.log("*****querySelect *****", response);
				if (response.resultCode == 10000) {
					this.changeItemList = response.data;
				}
			},
			//选择变量
			choChangeItem(val) {
				textInput = document.getElementById('textInput');
				let insert = textInput.selectionStart;
				this.inputValue = this.inputValue.substr(0, insert) + val + this.inputValue.substr(insert);
				textInput.focus();
			},
			getInputIndex() {
				textInput = document.getElementById('textInput');
			},
			headerStyle({
				rowIndex,
				columnIndex
			}) {
				if (rowIndex == 0 && columnIndex == 1) {
					return 'text-align:center;color:#000000'
				} else {
					return 'text-align:left;padding:15px;color:#000000'
				}
			},
			cellStyle({
				columnIndex
			}) {
				if (columnIndex == 1) {
					return 'text-align:center;'
				} else {
					return 'text-align:left;padding:15px;'
				}
			},

			// 获取科室列表
			async getDepartmentList() {
				var api = "/manager/depType/getDepType"
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {

					},
				})
				console.log("*****querySelect getDepType*****", response)
				this.departmentList = response.data
			},

			// 获取话术
			async querySelect() {
				var api = "/manager/fixguid/utter/list/" + this.department
				const response = await this.util.postRequest({
					url: api,
					method: "GET",
					data: {

					},

				})
				console.log("response", response)
				if (response.data.length == 0) {
					this.$message.success("该科室暂无数据，请选择其他科室");
				} else {
					this.utterData = response.data
					console.log("this.type",this.type)
					if(this.type == 0){
						for(let i = 0 ; i < this.utterData[this.type].attrList.length; i++){
							if(this.utterData[this.type].attrList[i].attrName == 'reply_time'){
								this.reply_time = this.utterData[this.type].attrList[i].attrValue
							}
						}
					}
				}
			},

			//选择科室
			changeDep(val) {
				console.log("changeDep", val)
				this.querySelect()
			},


			async AddQuery(type) {
				// 新增话术
				// console.log("type",type)
				var api = "/manager/fixguid/utter/edit";
				let params
				params = {
					cid: type == 'add' ? '' : this.queryID,
					content: this.inputValue,
					type: 'text',
					sceneId: this.type
				}

				console.log("params", params)
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: params,
				});

				if (response.resultCode === "10000") {
					this.$message.success('保存成功')
					this.querySelect()
				} else {
					this.open2(response.desc)
				}


			},
			async delSelect() {
				// 删除话术
				var api = "/manager/fixguid/utter/del/" + this.deleteByid
				const response = await this.util.postRequest({
					url: api,
					method: "DELETE",
					data: {

					},

				});
				console.log("***** delSelect *****", response);

				if (response.resultCode === "10000") {
					this.$message.success('删除成功')
					this.querySelect()
				} else {
					this.open2(response.desc)
				}
			},
			async descripe() {
				// 删除话术
				var api = "/manager/simpleTalkCorpus/selecHelpIntro";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						type: this.type
					},
					itype: "1"
				});
				console.log("***** descripe *****", response);
				if (response.data === null || response.data === {}) {
					this.addQueryTitle.type = "add"
				} else {
					this.textobj = response.data
					this.addQueryTitle.type = "edit"
					if (this.textobj.useFlag === 1 || this.textobj.useFlag === "1") {
						this.textobj.useFlag = true
					} else if (this.textobj.useFlag === 0 || this.textobj.useFlag === "0") {
						this.textobj.useFlag = false
					}
				}
				console.log("this.textobj ===>", this.textobj)
			},
			async valueSelect() {
				// 查询变量
				var api = "/manager/variable/selectVariableList";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {},
					itype: "1"
				});
				console.log("*****querySelect *****", response);
				this.valueLst = response.data
			},
			choiceScript(val) {
				this.type = val
				this.sceneId = this.utterData[this.type].sceneId
				for(let i = 0 ; i < this.utterData[this.type].attrList.length; i++){
					if(this.utterData[this.type].attrList[i].attrName == 'reply_time'){
						this.reply_time = this.utterData[this.type].attrList[i].attrValue
					}
				}
				
			},
			clickAdd() {
				this.addQueryTitle.title = "新增话术"
				this.addQueryTitle.type = "add"
				this.inputValue = ""
				this.queryID = ""
				this.textobj.useFlag = ""
				this.addQuery = true
				this.changeItem = '';
			},
			edit(row) {
				this.addQueryTitle.title = "编辑话术"
				this.addQueryTitle.type = "edit"
				this.inputValue = row.content
				this.queryID = row.cid
				this.textobj.useFlag = ""
				this.addQuery = true
				this.changeItem = '';
				console.log("")
			},
			delet(row) {
				console.log("话术删除", row)
				const tipMsg = "是否确认删除"
				MessageBox.alert(tipMsg, "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
					showCancelButton: true,
				}).then(() => {
					this.deleteByid = row.cid
					this.delSelect()
				})
			},
			confirm(type) {
				if (this.inputValue === '') {
					this.open2(" 话术不能为空 ")
				} else {
					this.addQuery = false
					this.AddQuery(type)
				}
			},
			insertValue() {

			},
			// 保存属性
			async saveAttr() {
				var api = "/manager/fixguid/utter/modify/attr";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						sceneId: this.sceneId,
						attrMap: {
							reply_time: this.reply_time
						}
					},

				});
				
				
				
				if (response.resultCode === "10000") {
					this.$message.success('保存成功')
					this.querySelect()
				} else {
					this.open2(response.desc)
				}
			},


			save() {
				if (this.textobj.content === '') {
					this.open2(" 话术不能为空 ")
				} else {
					this.type = "7"
					this.inputValue = this.textobj.content
					this.queryID = this.textobj.id
					if (this.addQueryTitle.type === "add") {
						this.queryID = ""
					} else {
						this.queryID = this.textobj.id
					}

					if (this.textobj.useFlag === true) {
						this.textobj.useFlag = 1
					} else if (this.textobj.useFlag === false) {
						this.textobj.useFlag = 0
					}
					this.AddQuery(this.addQueryTitle.type)
				}
			},
			open1(info) {
				// const text = '保存成功'

				console.log(info)
			},
			open2(info) {
				const text = info + ' 保存失败 '
				this.$message.error(text)
			},

		}
	}
</script>

<style scoped="scoped">
	.radios {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		height: 30px;
		line-height: 30px;
		margin-top: 30px;
		font-size: 14px;
	}

	.buttons1 {
		text-align: right;
	}

	.dialog {
		height: 350px;
	}

	.el-radio-button__inner {
		@include change_size($font_size_normal)
	}
</style>
